import styled from "styled-components";
import { V3Body } from "../Typography";

export const V3BodyGrey35 = styled(V3Body)`
    color: ${({ theme }) => theme.v3.colors.grey35};
`;
